module.exports = __webpack_public_path__ + "static/media/learn1.ae3caa5b.jpeg";